var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronsRightRegular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5817 14.9625L5.58174 3.46251C5.01236 2.86501 4.06299 2.84313 3.46361 3.41563C3.15486 3.71063 3.00049 4.105 3.00049 4.49938C3.00049 4.87244 3.13918 5.24563 3.41649 5.53626L13.4255 16L3.41924 26.4625C2.84893 27.0621 2.86649 28.0113 3.46611 28.5838C4.06574 29.156 5.01486 29.1346 5.58736 28.5369L16.5874 17.0369C17.138 16.4563 17.138 15.5438 16.5817 14.9625ZM28.5817 14.9625L17.5817 3.46251C17.013 2.86501 16.063 2.84313 15.463 3.41563C15.1567 3.71063 15.0005 4.105 15.0005 4.49938C15.0005 4.87244 15.1392 5.24563 15.4165 5.53626L25.4255 16L15.4192 26.4625C14.8489 27.0621 14.8665 28.0113 15.4661 28.5838C16.0657 29.156 17.0149 29.1346 17.5874 28.5369L28.5874 17.0369C29.138 16.4563 29.138 15.5438 28.5817 14.9625Z",
    fill: "#585858"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronsRightRegular);
export default __webpack_public_path__ + "static/media/chevrons-right-regular.e795a560ff2b4f83b250aa39aca6acf1.svg";
export { ForwardRef as ReactComponent };